import React from 'react';

import { FilterChips } from '@pkg/components/Filters';
import { useAppSelector } from '@pkg/hooks';

import { useNFTsPageStore } from '@app/store/zustand';

import { ToggleGrid } from '../ToggleGrid';

import { FilterAction, FilterActionLabel, FiltersRowWrapper, FlexGroup, StyledFiltersRow } from './FiltersRow.style';

export function NftFiltersRow({ filteredResultCount }: { filteredResultCount?: number }) {
    const { isListView, setIsListView, setShowFilters, showFilters } = useNFTsPageStore();
    const marketplaceV1Enabled = useAppSelector((state) => state.featureFlags.features.marketplaceV1Enabled);

    return (
        <StyledFiltersRow>
            <FiltersRowWrapper>
                <FlexGroup>
                    <FilterAction pressed={showFilters} onAction={() => setShowFilters(!showFilters)}>
                        <FilterActionLabel>{showFilters ? 'Hide' : 'Show'} Filters</FilterActionLabel>
                    </FilterAction>
                </FlexGroup>

                <FlexGroup $alignEnd>
                    {marketplaceV1Enabled && <ToggleGrid selected={isListView} setSelected={setIsListView} />}
                </FlexGroup>
            </FiltersRowWrapper>

            <FilterChips filteredResultCount={filteredResultCount} />
        </StyledFiltersRow>
    );
}
